import { Progress as MantineProgressBar, MantineStyleProp } from "@mantine/core";

type Props = {
  value: number;
  label?: string;
  animated?: boolean;
  style?: MantineStyleProp;
  color?: string;
};

export const ProgressBar = ({ label, value, animated, style, color = "blue" }: Props) => {
  return (
    <MantineProgressBar.Root size="lg" style={style}>
      <MantineProgressBar.Section animated={animated} value={value} color={color}>
        <MantineProgressBar.Label>{label}</MantineProgressBar.Label>
      </MantineProgressBar.Section>
    </MantineProgressBar.Root>
  );
};
